// eslint-disable-next-line simple-import-sort/imports
import { defineNuxtPlugin } from '#app'
import { getCityFromDomain } from '@/utils/getCityFromDomain'
import { Mode } from '@/types/main'

/*
 Плагин для определения префикса города сайта
*/
export default defineNuxtPlugin({
  name: 'initHost',
  setup({ ssrContext }) {
    const { MODE } = useRuntimeConfig().public
    let cityPrefix = ''

    if (process.server) {
      const ssrHost = ssrContext?.event?.node?.req?.headers?.host || ''

      if (!ssrHost) createError({ statusCode: 500 })

      cityPrefix = getCityFromDomain(ssrHost, MODE as Mode)
    } else {
      cityPrefix = getCityFromDomain(window.location.host, MODE as Mode)
    }

    return {
      provide: {
        cityPrefix,
      },
    }
  },
})
